import React from "react";
import { SpaceRatioValidation } from "@/services/statistical-analysis-service";
import { BaseAlert } from "../base/BaseAlert";
import { useCapacityAlertState } from "./useCapacityAlertState";

export interface SizeCapacityAlertProps {
  spaceRatioValidation?: SpaceRatioValidation;
  localSizeCapacityRatio?: {
    ratio: number;
    isWithinStandard: boolean;
    status: string;
    warning: string | null;
  } | null;
  loading?: boolean;
  className?: string;
  "data-testid"?: string;
}

export const SizeCapacityAlert: React.FC<SizeCapacityAlertProps> = ({
  spaceRatioValidation,
  localSizeCapacityRatio,
  loading = false,
  className,
  "data-testid": testId = "size-capacity-alert",
}) => {
  const alertState = useCapacityAlertState({
    spaceRatioValidation,
    localSizeCapacityRatio,
    loading,
  });

  if (!alertState) {
    return null;
  }

  return (
    <BaseAlert
      {...alertState}
      size="compact"
      className={className}
      data-testid={testId}
    />
  );
};

SizeCapacityAlert.displayName = "SizeCapacityAlert";
